import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { loginURL } from "../../../../Config/Url";
import { tenantService } from "../../../../Services";
import { FORM_FIELDS } from "../../Constants";
import { Link } from "react-router-dom";
import "./Login.css";

const Login = ({ stepState, previousPage, nextPage, formData }) => {
  const { LOGIN_DATA } = FORM_FIELDS;

  const [validationMsg, setValidationMsg] = useState("");

  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const onNextPage = (data) => {
    axios
      .post(loginURL, { username: data.username, password: data.password })
      .then((res) => {
        const bearerToken = res?.data?.user?.token?.accessToken;
        if (bearerToken) {
          tenantService
            .getTenantPublicOnboadring({
              // 79254194816,
              params: { oib: data?.[FORM_FIELDS.LOGIN_DATA.OIB.name] },
              bearer: bearerToken,
            })
            .then((res) => {
              if (res?.status === 200) {
                nextPage({
                  [FORM_FIELDS.STORE_DATA.name]: res?.data?.data,
                  [FORM_FIELDS.LOGIN_DATA.name]: {
                    ...data,
                    [FORM_FIELDS.LOGIN_DATA.BEARER_TOKEN.name]: bearerToken,
                  },
                });
                return;
              }
              setValidationMsg(
                <>
                  OIB klijenta ne postoji u sustavu.{" "}
                  <Link to="/public/onboarding">Dodajte novog klijenta?</Link>
                </>
              );
            });
        }
      })
      .catch((err) => {
        setValidationMsg("Korisničko ime ili lozinka nisu ispravni.");
      });
  };

  return (
    <div className="public-onboarding-existing__login-root">
      <legend className="scheduler-border mb-3">Prijava</legend>
      {validationMsg && (
        <div className="invalid-record my-3 p-3">{validationMsg}</div>
      )}
      <div className="form-container">
        <div className="form-group">
          <label htmlFor="taxNumber">
            {LOGIN_DATA.USERNAME.title} <b>*</b>
          </label>
          <input
            className="form-control"
            type="text"
            name={LOGIN_DATA.USERNAME.name}
            ref={register()}
          />
        </div>
        <div className="form-group">
          <label htmlFor="taxNumber">
            {LOGIN_DATA.PASSWORD.title} <b>*</b>
          </label>
          <input
            className="form-control"
            type="password"
            name={LOGIN_DATA.PASSWORD.name}
            ref={register()}
          />
        </div>
        <div className="form-group">
          <label htmlFor="taxNumber">
            {LOGIN_DATA.OIB.title} <b>*</b>
          </label>
          <input
            className="form-control"
            type="text"
            defaultValue={"79254194816"}
            name={LOGIN_DATA.OIB.name}
            ref={register()}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 text-right">
          <button
            className="btn btn-primary"
            onClick={handleSubmit(onNextPage)}
          >
            Sljedeći korak
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
